/* eslint-disable import/prefer-default-export */
import {
  ref, computed, onMounted, onUnmounted,
} from '@vue/composition-api'
import {
  loadOrderPlannerConfig,
  normalizeOrderPlannerConfig,
  normalizePlannerViewMode,
  normalizePlannerShowBuffer,
  saveOrderPlannerConfig,
  ORDER_PLANNER_CONFIG_EVENT,
} from '@/views/orders/Planner/plannerConfig'
import { resolveAutomaticPlannerViewMode } from '@/views/orders/Planner/setup'

export const usePlannerConfig = route => {
  const storedConfig = loadOrderPlannerConfig()

  const viewMode = ref(normalizePlannerViewMode(route.value.query.view || storedConfig.viewMode))
  const showBuffer = ref(
    route.value.query.buffer == null
      ? storedConfig.showBuffer
      : normalizePlannerShowBuffer(route.value.query.buffer),
  )
  const stickyHeaders = ref(storedConfig.stickyHeaders)
  const showBacklog = ref(storedConfig.showBacklog)
  const showStats = ref(storedConfig.showStats)
  const hasManualViewModePreference = ref(storedConfig.isViewModeManual)

  const hasRouteViewModeOverride = computed(() => ['scheduler', 'timeline'].includes(route.value.query.view))

  saveOrderPlannerConfig({
    viewMode: viewMode.value,
    showBuffer: showBuffer.value,
    stickyHeaders: stickyHeaders.value,
    showBacklog: showBacklog.value,
    showStats: showStats.value,
    isViewModeManual: hasManualViewModePreference.value,
  })

  const applyAutomaticViewMode = resourcesCount => {
    if (hasRouteViewModeOverride.value || hasManualViewModePreference.value) {
      return
    }
    const next = resolveAutomaticPlannerViewMode(resourcesCount)
    if (next === viewMode.value) {
      return
    }
    viewMode.value = next
    saveOrderPlannerConfig({
      viewMode: next,
      showBuffer: showBuffer.value,
      showBacklog: showBacklog.value,
      showStats: showStats.value,
      isViewModeManual: false,
    })
  }

  const handleConfigChange = event => {
    const nextConfig = normalizeOrderPlannerConfig(event?.detail || loadOrderPlannerConfig())
    viewMode.value = nextConfig.viewMode
    showBuffer.value = nextConfig.showBuffer
    stickyHeaders.value = nextConfig.stickyHeaders
    showBacklog.value = nextConfig.showBacklog
    showStats.value = nextConfig.showStats
    hasManualViewModePreference.value = nextConfig.isViewModeManual
  }

  onMounted(() => {
    if (typeof window !== 'undefined') {
      window.addEventListener(ORDER_PLANNER_CONFIG_EVENT, handleConfigChange)
    }
  })

  onUnmounted(() => {
    if (typeof window !== 'undefined') {
      window.removeEventListener(ORDER_PLANNER_CONFIG_EVENT, handleConfigChange)
    }
  })

  return {
    viewMode,
    showBuffer,
    stickyHeaders,
    showBacklog,
    showStats,
    hasRouteViewModeOverride,
    hasManualViewModePreference,
    applyAutomaticViewMode,
  }
}
